export const token = localStorage.getItem("GISToken") !== null
    ? localStorage.getItem("GISToken")
    : sessionStorage.getItem("GISToken") !== null
        ? sessionStorage.getItem("GISToken")
        : null
